__turbopack_context__.v({
  "header": "jfOynq_header",
  "header__actions": "jfOynq_header__actions",
  "header__active-region": "jfOynq_header__active-region",
  "header__hamburger": "jfOynq_header__hamburger",
  "header__logo": "jfOynq_header__logo",
  "header__logo-link": "jfOynq_header__logo-link",
  "header__mobile-actions": "jfOynq_header__mobile-actions",
  "header__primary": "jfOynq_header__primary",
  "header__secondary": "jfOynq_header__secondary",
  "header__secondary-link": "jfOynq_header__secondary-link",
  "header__secondary-link--large": "jfOynq_header__secondary-link--large",
  "header__secondary-list": "jfOynq_header__secondary-list",
});
